<template>
    <div class="bg-toolbar-hc">
        <v-overlay absolute :value="loading_overlay" color="#757575" opacity="0.5">
            <v-progress-circular :size="80" :width="5" color="#1DBB97" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- Top Toolbar -->
        <v-row class="toolbar-row-hc toolbar-block-hc">
            <v-toolbar elevation="0" height="80" class="padding-nav">
                <v-app-bar-nav-icon @click="toggleMenu()" color="#1DBC97"></v-app-bar-nav-icon>
                <v-toolbar-title class="pl-6">
                    <img height="30px" src="../../assets/Petty_Cash.png">
                    <img height="27px" src="../../assets/logo_font_hc.png" class="ml-3 display-pc-only">
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items class="toolbar-hc-block">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn text v-on="on" class="btn-user-height">
                                <v-icon large color="rgb(0 0 0 / 38%)">mdi-account-circle</v-icon>
                                <div class="ml-2 display-pc-only">
                                    <v-row class="toolbar-row-hc username-hc">
                                        {{firstname}} {{lastname}}
                                    </v-row>
                                    <v-row class="toolbar-row-hc email-hc">
                                        {{thai_email}}
                                    </v-row>
                                </div>
                                <!-- <v-icon color="#757575" class="toolbar-menu-icon-hc">mdi-menu-down</v-icon> -->
                            </v-btn>
                        </template>
                        <!-- <v-list nav dense>
                            <v-list-item @click="logout()">
                                <v-list-item-title class="toolbar-menu-title-hc">ออกจากระบบ</v-list-item-title>
                            </v-list-item>
                        </v-list> -->
                    </v-menu>
                </v-toolbar-items>
            </v-toolbar>
        </v-row>
        <v-navigation-drawer elevation="0" width="248" class=" border-del-hc color-nav-hc" app v-model="drawer" :mini-variant="mini" mini-variant-width="72">
            <v-list nav color="white" class="list-menu-hc border-ra-hc list-nav-hc pt-8 padding-mini-hc">
                <v-list-item to="/pettycash_hc_dashboard/dashboard" class="rounded-lg pl-3">
                    <v-list-item-icon class="mr-2">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 21H18V11H21V21ZM16 21H13V8H16V21ZM11 21H8V5H11V21ZM6 21H3V13H6V21Z" fill="#1DBB97"/>
                        </svg></v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="list-navigation-hc">Dashboard</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item to="/pettycash_hc_dashboard/item_dashboard" class="rounded-lg pl-3">
                    <v-list-item-icon class="mr-2">
                    <v-icon color="#1DBB97">mdi-chart-timeline-variant</v-icon>  
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="list-navigation-hc">Item</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item to="/pettycash_hc_dashboard/department_dashboard" class="rounded-lg pl-3">
                    <v-list-item-icon class="mr-2">
                    <v-icon color="#1DBB97">mdi-card-account-details</v-icon>  
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="list-navigation-hc">Department</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            
        </v-navigation-drawer>
        
        <v-container fluid class="main-content-hc">
            
                <router-view/>
            
        </v-container>
    </div>
</template>

<script>
    export default {
        data: () => ({
            loading_overlay: false,
            drawer: true,
            mini: false,
            firstname: '',
            lastname: '',
            thai_email: '',
        }),
        mounted(){
            this.getUserDetail()
        },
        methods: {
            async getUserDetail(){
                var sessionDetail = JSON.parse(sessionStorage.getItem('userProfile'))
                sessionStorage.setItem('name', `${sessionDetail.first_name_th} ${sessionDetail.last_name_th}`)
                this.firstname = sessionDetail.first_name_th
                this.lastname = sessionDetail.last_name_th
                this.thai_email = sessionDetail.thai_email
            },
            toggleMenu() {
                var screen_size_breakpoint = this.$vuetify.breakpoint.name
                if(screen_size_breakpoint=='xs' || screen_size_breakpoint=='sm' || screen_size_breakpoint=='md') {
                    this.mini = false
                    this.drawer = !this.drawer
                } else {
                    this.mini = !this.mini
                }
            },
            logout() {
                sessionStorage.clear()
                localStorage.clear()
                this.$router.push("/login")
            },
        }
    }
</script>

<style>
    .v-toolbar__items > .v-btn.btn-user-height {
        height: 38px !important;
        border-radius: 8px !important;
    }

    .padding-nav .v-toolbar__content {
        padding-left: 2% !important;
        padding-right: 3% !important;
    }

    .bg-toolbar-hc {
        background-image: url('../../assets/BG_hc.svg');
        background-color: #f3f5f7;
        width: 100%;
        height: 100%;
        /* height: calc(100vh - 80px); */
        background-size: cover;
        background-attachment: fixed;
    }

    .toolbar-row-hc {
        width: 100%;
        margin: 0% !important;
    }

    .toolbar-block-hc {
        z-index: 10;
        position: fixed;
        top: 0;
        left: 0;
    }

    .toolbar-hc-block {
        align-items: center;
    }

    .list-navigation-hc {
        font-family: 'Noto Sans Thai', sans-serif;
        font-size: 16px !important;
        font-weight: 600 !important;
        line-height: 24px !important;
        color: #1DBB97;
        
    }

    .username-hc {
        font-family: 'Noto Sans Thai', sans-serif;
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 24px !important;
        color: #333333;
    }

    .email-hc {
        font-family: 'Noto Sans Thai', sans-serif;
        font-size: 10px !important;
        font-weight: 400 !important;
        line-height: 16px !important;
        color: #757575;
        text-transform: lowercase;
    }

    .toolbar-menu-title-hc {
        font-family: 'Noto Sans Thai', sans-serif;
        font-size: 14px !important;
        line-height: 24px !important;
    }

    .toolbar-menu-icon-hc {
        margin-left: 6%;
        margin-bottom: 8%;
    }


    .list-menu-hc {
        margin-top: 88px;
    }

    .theme--light .border-del-hc.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {
        background-color: transparent !important;
    }

    .border-ra-hc {
        border-top-right-radius: 12px !important;
        border-bottom-right-radius: 12px !important;
    }

    .color-nav-hc {
        background: linear-gradient(180deg, rgba(243,245,247,1) 0%, rgba(180,235,231,1) 100%) !important;
    }

    .list-nav-hc {
        height: calc(100vh - 88px);
    }

    .main-content-hc {
        padding-top: 80px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
    }

    .padding-mini-hc {
        padding-left: 13% !important;
        padding-right: 13% !important;
    }

    /*========================================*/

  @media only screen and (max-width:600px){ /*css for mobile screen*/
    .color-nav-hc {
        background: white !important;
    }
  }

</style>
